import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import { toggleAddFundsModal } from "../../redux/WalletSlice";
import Amount from "./walletusables/Amount";
import { useDispatch } from "react-redux";
import Channel from "./walletusables/Channel";
import DepositAccountDetails from "./walletusables/DepositAccountDetails";
import SuccessModal from "../../components/SuccessModal";

const DepositFlow = ({ activeDepositTab, setActiveDepositTab }) => {
	const dispatch = useDispatch();
	const [verifyPaymentLoading, setVerifyPaymentLoading] = useState(false);
	const [data, setData] = useState(null);
	const [paymentDetails, setPaymentDetails] = useState({
		amountToDeposit: "",
		paymentChannel: "",
	});
	const { amountToDeposit, paymentChannel } = paymentDetails;

	const handleChange = (e) => setPaymentDetails((prev) => ({ ...prev, [e.target.name]: e.target.value }));

	const onCloseModal = () => {
		dispatch(toggleAddFundsModal(false));
		setPaymentDetails({
			paymentChannel: "",
			sendersName: "",
			amountToDeposit: "",
		});
	};

	const onVerifyPayment = () => {
		setVerifyPaymentLoading(true);

		setTimeout(() => {
			setVerifyPaymentLoading(false);
		}, 30 * 1000);

		setTimeout(() => {
			setData("confirmation in progrees");
		}, 30 * 1000);
	};

	const onProceed = () => {
		window.location.reload();
	};

	useEffect(() => {
		if (data) {
			setActiveDepositTab(4);
		} else {
			return;
		}
	}, [data]);

	return (
		<>
			{activeDepositTab === 1 && (
				<Amount
					amount={amountToDeposit}
					handleChange={handleChange}
					onCloseModal={onCloseModal}
					onProceed={() => setActiveDepositTab(2)}
					context='Enter an amount to deposit to your wallet'
					title='amountToDeposit'
				/>
			)}
			{activeDepositTab === 2 && (
				<Channel
					onProceed={() => setActiveDepositTab(3)}
					onReturn={() => setActiveDepositTab(1)}
					onCloseModal={onCloseModal}
					paymentChannel={paymentChannel}
					onSelect={(mode) =>
						setPaymentDetails((prev) => ({
							...prev,
							paymentChannel: mode,
						}))
					}
				/>
			)}
			{activeDepositTab === 3 && (
				<DepositAccountDetails
					onCloseModal={onCloseModal}
					onReturn={() => setActiveDepositTab(2)}
					paymentChannel={paymentChannel}
					amountToDeposit={amountToDeposit}
					verifyPaymentLoading={verifyPaymentLoading}
					onVerify={onVerifyPayment}
				/>
			)}
			{activeDepositTab === 4 && (
				<SuccessModal
					isPending
					btnText='reload page'
					modalText='Confirmation in progress. When confirmed, funds will be added to wallet and a mail will be sent to you.'
					onReqClick={onProceed}
				/>
			)}
		</>
	);
};

export default DepositFlow;

DepositFlow.propTypes = {
	activeDepositTab: PropTypes.number,
	setActiveDepositTab: PropTypes.func,
};
